import { Card } from 'antd';
import React from 'react';
import DocumentPreview360 from './DocumentPreview360';

const CardDocumentPreview360 = ({
  height,
  width,
  cardProps,
  documentProps
}) => {
  const finalHeight = height || 200;
  const finalWidth = width || 141;
  return (
    <Card
      {...cardProps}
      bodyStyle={{
        height: finalHeight,
        width: finalWidth,
        padding: 0
      }}
    >
      <DocumentPreview360
        height={finalHeight}
        width={finalWidth}
        {...documentProps}
      />
    </Card>
  );
};

export default CardDocumentPreview360;
